
// TODO - Type 'any' needs to be fixed.

export const resetEditDraftShiftReducer = (state:any) => {
    state.editDraftShift.status = "idle";
    state.editDraftShift.errorMessage = "";
    state.editDraftShift.shiftId = null;
  }